<template>
    <div>
        <div class="popup__header">
            <span class="title title--sm popup__title">{{ title }}</span>
            <div class="popup__description">
                <span class="add__lock-text">{{ description }}</span>
            </div>
        </div>
        <div class="popup__content">
            <form class="form" @submit.prevent="updateAccess">
                <div class="form__item">
                    <label class="form__inner">
                        <span class="form__label">{{ $lang('pagePassword.password') }}</span>
                        <el-input class="input input--big" type="password" placeholder="******" v-model="wrapPassword"
                                  :maxlength="maxLength"
                                  required
                                  show-password/>
                    </label>
                </div>
                <div class="form__item">
                    <button class="btn btn--middle btn--main-bg">{{ $lang('pagePassword.save') }}</button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import width from "../mixins/width";
import Vue from "vue";

export default {
    name: "SetPasswordPopup",
    mixins: [width],
    props: {
        params: {
            type: Object | null,
            default: null,
        },
        password: {
            type: String|null,
            requested: true
        },
        accessByPassword: {
            type: String,
            requested: true
        },
        accessPassword: {
            type: String,
            requested: true
        },
        description: {
            type: String,
            default: () => Vue.prototype.$lang('pagePassword.text')
        },
        title: {
            type: String,
            default: () => Vue.prototype.$lang('pagePassword.title')
        }
    },
    data() {
        return {
            wrapPassword: this.password,
            maxLength: 250
        }
    },
    methods: {
        updateAccess() {
            let params = this.params !== null
                ? {value: this.wrapPassword, ...this.params}
                : this.wrapPassword;

            this.$store.commit(this.accessPassword, params);

            let sendPasswordState = this.params !== null
                ? {value: true, ...this.params}
                : true;

            this.$store.commit(this.accessByPassword, sendPasswordState);

            this.$router.back();
        }
    }
}
</script>

<style>
.popup__description {
    margin-top: 15px;
}
</style>
